// extracted by mini-css-extract-plugin
module.exports = {"packagePickupContainer":"PackagePickup_packagePickupContainer__1xF9R","packageList":"PackagePickup_packageList__x5twh","packageItem":"PackagePickup_packageItem__U1wgE"};